export function computeDomain(segmentParams) {
  let doms = []
  segmentParams.map(sspp => {
    if (!Array.isArray(sspp)) sspp = [sspp]
    sspp.forEach(sp => {
      if (sp.value && sp.value[0] && sp.value[0].value && sp.value[0].value[1]) {
        let dom = {
          min: sp.value[0].value[1].view.validate_min,
          max: sp.value[0].value[1].view.validate_max,
        }
        if (dom.min !== dom.max) {
          dom.label =
            sp.value[0].value[1].view.name +
            (sp.value[0].value[1].view.units ? ` (${sp.value[0].value[1].view.units})` : '')
        } else {
          dom.label = sp.view.name
        }
        doms.push(dom)
      } else {
        doms.push({ min: 0, max: 1, label: sp.view ? sp.view.name : ''})
      }
    })
  })

  if (doms.length === 0) doms = [{ min: 0, max: 1 }]
  let dom = doms.reduce(
    (res, dom) => {
      let min = dom.min.length === 2 ? dom.min[0] : dom.min
      let max = dom.max.length === 2 ? dom.max[1] : dom.max
      res[0] = Math.min(res[0], min)
      res[1] = Math.max(res[1], max)

      if (!res.label) res.label = []
      if (dom.label) res.label.push(dom.label)

      return res
    },
    [Infinity, -Infinity]
  )
  dom.label = dom.label.join(' / ')
  return dom
}
